// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const azumarill: PokeData = {
  "id": 184,
  "name": "azumarill",
  "height": 8,
  "weight": 285,
  "base_experience": 189,
  "types": [
    PokeType.WATER,
    PokeType.FAIRY
  ],
  "api_moves": [
    "slam",
    "tackle",
    "double-edge",
    "tail-whip",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "defense-curl",
    "bubble",
    "splash",
    "charm",
    "rollout",
    "rain-dance",
    "helping-hand",
    "superpower",
    "bounce",
    "water-sport",
    "aqua-ring",
    "aqua-tail",
    "play-rough"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "splash",
    "rain-dance",
    "superpower",
    "aqua-tail",
    "play-rough",
    "water-spout",
    "guardian-bond",
    "moonblast",
    "spirit-break"
  ],
  "evolution_chain": {
    "id": 90,
    "item": {
      "name": "sea-incense"
    },
    "species": [
      {
        "name": "azurill",
        "order": 211,
        "types": [
          PokeType.NORMAL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "marill",
        "order": 212,
        "types": [
          PokeType.WATER,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 298,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "azumarill",
        "order": 213,
        "types": [
          PokeType.WATER,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 183,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 180,
    "speed": 100,
    "ability_power": 120
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
